import type { PlatformSettingNameType, SetupStepType } from '@/features/admin/platform-setup/constants'

type SettingRowType = { name: string; value?: string | null }

export type ChecklistItemKeyType = 'identity' | 'branding' | 'login' | 'support' | 'legal'

export type ChecklistItemType = {
  key: ChecklistItemKeyType
  step: SetupStepType
  done: boolean
}

export function toSettingsMap(rows: SettingRowType[] | undefined): Partial<Record<PlatformSettingNameType, string>> {
  const map: Partial<Record<PlatformSettingNameType, string>> = {}
  for (const row of rows ?? []) {
    map[row.name as PlatformSettingNameType] = row.value ?? ''
  }
  return map
}

const filled = (settings: Partial<Record<PlatformSettingNameType, string>>, ...names: PlatformSettingNameType[]) =>
  names.every((name) => (settings[name] ?? '').trim() !== '')

export function isSamlConfigured(settings: Partial<Record<PlatformSettingNameType, string>>) {
  return settings.SAML_LOGIN_ENABLED === 'true' && filled(settings, 'SAML_IDP_SSO_URL', 'SAML_CERTIFICATE')
}

/** Ce qu'il reste à régler sur la plateforme, d'après les paramètres enregistrés. */
export function computeChecklist(settings: Partial<Record<PlatformSettingNameType, string>>): ChecklistItemType[] {
  return [
    { key: 'identity', step: 'identity', done: filled(settings, 'COMPANY_NAME', 'TITLE') },
    { key: 'branding', step: 'branding', done: filled(settings, 'LOGO_SMALL', 'COLOR_PRIMARY') },
    {
      key: 'login',
      step: 'login',
      done: settings.EMAIL_LOGIN_ENABLED === 'true' || isSamlConfigured(settings),
    },
    { key: 'support', step: 'contact', done: filled(settings, 'SUPPORT_EMAIL') },
    {
      key: 'legal',
      step: 'contact',
      done: filled(settings, 'LEGAL_RT_ORGANISME_NAME', 'LEGAL_RT_CONTACT_ADDRESS', 'LEGAL_RT_DPO_EMAIL'),
    },
  ]
}

/** Une étape est complète quand tous les points qu'elle porte le sont. */
export function isStepComplete(items: ChecklistItemType[], step: SetupStepType) {
  return items.filter((item) => item.step === step).every((item) => item.done)
}
